module.exports = __webpack_public_path__ + "static/media/pointing_ring_01.1673231c.png";